import style from "../../styles/instructionview";
import RaisedButton from "material-ui/RaisedButton";
import React from "react";
import IconLibrary from "material-ui/svg-icons/av/library-books";

export default (props) => {
  return (
    <div>
      {props.documents && props.documents.length > 0 && (
        <div style={style.labelContainer}>
          <p>
            <label style={style.label}>Documents :</label>
            {props.documents.map((document, index) => {
              return (
                <RaisedButton
                  style={{ margin: 5 }}
                  primary={true}
                  label={document.name}
                  icon={<IconLibrary />}
                  onClick={() => window.open(document.url, "blank")}
                />
              );
            })}
          </p>
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/DocumentView.js